import { blueGrey, common } from '@material-ui/core/colors';

const secondary = Object.assign( {}, blueGrey, {
    contrastText: common.white,
    dark: blueGrey[900],
    light: blueGrey[700],
    main: blueGrey[800],
} );
export default secondary;
